<button
  (click)="buttonInteraction()"
  [attr.data-omni-qa]="omniQaTag"
  [disabled]="disabled"
  type="button"
>
  {{ copy }}
</button>
